var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 23.3h-5.7c-.6 0-1 .4-1 1v6.4c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.6-.4-1-1-1zm-1 6.4h-3.7v-4.4h3.7zM25.9 28.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1zM21.2 36.5h-5.7c-.6 0-1 .4-1 1v6.4c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.6-.4-1-1-1zm-1 6.3h-3.7v-4.4h3.7zM41.6 37.3H25.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1zM41.6 42H25.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1 0-.5-.4-1-1-1zM21.2 49.6h-5.7c-.6 0-1 .4-1 1V57c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.5-.4-1-1-1zm-1 6.4h-3.7v-4.4h3.7zM41.6 50.4H25.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1 0-.5-.4-1-1-1zM41.6 55.2H25.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8 1.6c-2.1 0-4.1.5-5.9 1.4H6.8C4.9 3 3.4 4.5 3.4 6.4v54.5c0 1.9 1.5 3.4 3.5 3.4h38.3c1.9 0 3.4-1.5 3.4-3.4V29.2h.3c7.6 0 13.8-6.2 13.8-13.8-.1-7.6-6.3-13.8-13.9-13.8zm-2.3 59.3c0 .8-.7 1.4-1.4 1.4H6.8c-.8 0-1.5-.7-1.5-1.4V6.4C5.4 5.6 6 5 6.8 5h33C36.9 7.5 35 11.3 35 15.4c0 3.3 1.2 6.3 3.1 8.7H25.9c-.6 0-1 .4-1 1s.4 1 1 1h14.2c1.8 1.5 4 2.5 6.4 2.9zm2.3-33.7c-6.5 0-11.8-5.3-11.8-11.8S42.3 3.6 48.8 3.6s11.8 5.3 11.8 11.8-5.3 11.8-11.8 11.8z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 20.7h-8.9V10.1h8.9c.6 0 1-.4 1-1s-.4-1-1-1h-9.9c-.6 0-1 .4-1 1v12.5c0 .6.4 1 1 1h9.9c.6 0 1-.4 1-1 0-.5-.4-.9-1-.9z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.5 12.2-3.9 3.9-1.4-1.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.1 2.1c.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4-.4-.3-1-.3-1.4 0zM19.9 20.3v-1.6c0-2.3-1.2-4.2-3.1-5.2.9-.8 1.5-1.9 1.5-3.2 0-2.3-2-4.2-4.5-4.2S9.3 8 9.3 10.3c0 1.3.6 2.4 1.5 3.2-1.8 1-3.1 3-3.1 5.2v1.6c0 .6.4 1 1 1h10c.8 0 1.2-.5 1.2-1zM13.9 8c1.4 0 2.5 1 2.5 2.2s-1.1 2.2-2.5 2.2-2.5-1-2.5-2.2S12.5 8 13.9 8zm4 11.3h-8v-.6c0-2.2 1.8-4 4-4s4 1.8 4 4z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.6102870f0a6abea72553cf098d216bcb.svg";
export { ForwardRef as ReactComponent };